import { useEffect } from 'react';

// То же название, что зашито в public/index.ejs. Остаётся в одиночку на
// экранах вне навигации — вход, оплата: там страницы в меню нет и подставлять
// нечего.
const BASE_DOCUMENT_TITLE = 'ByHelp';
const TITLE_SEPARATOR = ' - ';

interface UseDocumentTitleParams {
  pageTitle: string | JSX.Element;
}

// Заголовок вкладки берём из того же названия страницы, что показывает шапка
// (getPageTitle в usePage), — второй список названий не заводим.
export const useDocumentTitle = ({
  pageTitle,
}: UseDocumentTitleParams): void => {
  useEffect(() => {
    // label в навигации объявлен как string | JSX.Element. Фактически все
    // пункты строковые, но разметку в заголовок вкладки не положить — для неё
    // остаётся базовое название.
    const pageName = typeof pageTitle === 'string' ? pageTitle.trim() : '';

    document.title = pageName
      ? `${BASE_DOCUMENT_TITLE}${TITLE_SEPARATOR}${pageName}`
      : BASE_DOCUMENT_TITLE;
  }, [pageTitle]);
};
